// chart-config.service.ts
import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import { ChartThemeService } from './chart-theme.service';

@Injectable({
  providedIn: 'root',
})
export class ChartConfigService {
  constructor(private themeService: ChartThemeService) {}

  getLineChartConfig(): Highcharts.Options {
    return {
      chart: {
        type: 'line',
        zooming: {
          type: 'x',
        },
        backgroundColor: '#323232',
        borderRadius: 5,
      },
      title: {
        text: undefined,
        style: {
          color: '#E0E0E3',
        },
      },
      credits: { enabled: false },
      colors: this.themeService.getCurrentPalette(),
      xAxis: {
        type: 'datetime',
        lineColor: '#707073',
        tickColor: '#707073',
        labels: {
          style: {
            color: '#E0E0E3',
          },
        },
      },
      yAxis: {
        title: { text: undefined },
        gridLineColor: 'rgba(255, 255, 255, 0.1)',
        labels: {
          style: {
            color: '#E0E0E3',
          },
        },
      },
      tooltip: {
        shared: true,
        valueDecimals: 2,
      },
      plotOptions: {
        series: {
          marker: {
            enabled: false,
          },
        },
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'top',
        borderWidth: 0,
        itemStyle: {
          color: '#E0E0E3',
        },
        itemHoverStyle: {
          color: '#FFF',
        },
        itemHiddenStyle: {
          color: '#606063',
        },
      },
      exporting: {
        enabled: false,
      },
    };
  }

  // Other chart type configurations...
}
